import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
body {
    margin: 0;
    padding: 0;
    // background-color:#141414;
    overflow:hidden;
    /* App font color (admin Config). Screens that don't hardcode a color inherit this. */
    color: var(--app-font-color, #ffffff);
    /* App font family (admin Config). Screens inherit this; the primary "DM Sans"
       declarations across the app also reference the same variable. */
    font-family: var(--app-font-family, "DM Sans", sans-serif);
}
`;

export default GlobalStyle;
